export default {
  data() {
    return {
      amarReports: [
        {
          title: 'گزارش سفارشی',
          id: 1,
          icon: 'mdi-clipboard-text ',
          icon2: 'mdi-clipboard-text mdi-36px',
          background: 'background:#00305A',
          background2: 'background:#1F496E',
        },
        {
          title: 'آمار روزانه',
          id: 12,
          icon: 'mdi-book',
          icon2: 'mdi-book mdi-36px',
          background: 'background:#0067A6',
          background2: 'background:#1F79B1',
        },
        {
          title: 'گزارش کدها در شیفت',
          id: 2,
          icon: 'mdi-motorbike',
          icon2: 'mdi-motorbike mdi-36px',
          background: 'background:#0092B2',
          background2: 'background:#1F9FBB',
        },
        {
          title: 'گزارش زمان ها',
          id: 13,
          icon: 'mdi-timer',
          icon2: 'mdi-timer mdi-36px',
          background: 'background:#00bbe6',
          background2: 'background:#007d99',
        },
        {
          title: 'گزارش پرونده ها (بایگانی)',
          id: 3,
          icon: 'mdi-file-document ',
          icon2: 'mdi-file-document mdi-36px',
          background: 'background:#04BFBF',
          background2: 'background:#22C7C7',
        },
        // {
        //   title: "گزارش پایگاه",
        //   id: 4,
        //   icon: "mdi-home-city",
        //   icon2: "mdi-home-city mdi-36px",
        //   background: "background:#4C1273",
        //   background2: "background:#602E83",
        // },
        {
          title: 'گزارش سوخت گیری',
          id: 5,
          icon: 'mdi-gas-station',
          icon2: 'mdi-gas-station mdi-36px',
          background: 'background:#512DA8',
          background2: 'background:#6646B2',
        },
        {
          title: 'گزارش تماس ها',
          id: 6,
          icon: 'mdi-phone mdi-flip-h',
          icon2: 'mdi-phone mdi-flip-h mdi-36px',
          background: 'background:#7B1FA2',
          background2: 'background:#8B3AAD',
        },
        // {
        //   title: "گزارش ممیزی",
        //   id: 7,
        //   icon: "mdi-text ",
        //   icon2: "mdi-text mdi-36px",
        //   background: "background:#AB47BC",
        //   background2: "background:#B55DC4",
        // },
        {
          title: 'گزارش مبتنی بر نقشه',
          id: 8,
          icon: 'mdi-map',
          icon2: 'mdi-map mdi-36px',
          background: 'background:#04756F',
          background2: 'background:#2A898B',
        },
        {
          title: 'گزارش شروع به کار',
          id: 10,
          icon: 'mdi-airplane-check',
          icon2: 'mdi-airplane-check mdi-36px',
          background: 'background:#00bbe6',
          background2: 'background:#007d99',
        },
        {
          title: 'گزارش زمین گیر شدن هلیکوپتر',
          id: 11,
          icon: 'mdi-airplane-alert',
          icon2: 'mdi-airplane-alert mdi-36px',
          background: 'background:#04BFBF',
          background2: 'background:#22C7C7',
        },
        {
          title: 'گزارش جابه جایی هلیکوپتر',
          id: 14,
          icon: 'mdi-helicopter',
          icon2: 'mdi-helicopter mdi-36px',
          background: 'background:#512DA8',
          background2: 'background:#6646B2',
        },
        {
          title: 'گزارش سوختگیری امداد هوایی',
          id: 15,
          icon: 'mdi-fuel',
          icon2: 'mdi-fuel mdi-36px',
          background: 'background:#0092B2',
          background2: 'background:#1F9FBB',
        },
        {
          title: 'گزارش نشست و برخاست',
          id: 15,
          icon: 'mdi-airplane-takeoff',
          icon2: 'mdi-airplane-takeoff mdi-36px',
          background: 'background:#00305A',
          background2: 'background:#1F496E',
        },

        // {
        //   title: "گزارش پیک پشت خطی ها",
        //   id: 10,
        //   icon: "mdi-phone-ring",
        //   icon2: "mdi-phone-ring mdi-36px",
        //   background: "background:#45BF55",
        //   background2: "background:#5EC577",
        // },
      ],
      searchTitle: '',
    };
  },
  methods: {
    goToReport: function (title) {
      if (title == 'گزارش سفارشی') {
        this.$router.push({ name: 'customReportAmar' });
      } else if (title == 'آمار روزانه') {
        this.$router.push({ name: 'dailyReportAmar' });
      } else if (title == 'گزارش پرونده ها (بایگانی)') {
        this.$router.push({ name: 'missionReport' });
      } else if (title == 'گزارش کدها در شیفت') {
        this.$router.push({ name: 'phoneActivityReport' });
      } else if (title === 'گزارش زمان ها') {
        this.$router.push({ name: 'average-times-report' });
      } else if (title == 'گزارش پایگاه') {
        console.log('not found');
      } else if (title == 'گزارش سوخت گیری') {
        this.$router.push({ name: 'refuelReportAmar' });
      } else if (title == 'گزارش تماس ها') {
        this.$router.push({ name: 'qcCallsReport' });
      } else if (title == 'گزارش ممیزی') {
        console.log('not found');
      } else if (title == 'گزارش مبتنی بر نقشه') {
        this.$router.push({ name: 'heatMapReportAmar' });
      } else if (title === 'گزارش شروع به کار') {
        this.$router.push({ name: 'workStartList' });
      } else if (title === 'گزارش نشست و برخاست') {
        this.$router.push({ name: 'takeoffAndLanding' });
      } else if (title === 'گزارش زمین گیر شدن هلیکوپتر') {
        this.$router.push({ name: 'helicopterGrounding' });
      } else if (title === 'گزارش جابه جایی هلیکوپتر') {
        this.$router.push({ name: 'helicopterReplacement' });
      } else if (title === 'گزارش سوختگیری امداد هوایی') {
        this.$router.push({ name: 'airAmbulanceRefuel' });
      }
    },
  },
};
